var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { request as __request } from '../core/request';
export class PrezilinkerService {
    /**
     * Return list of links
     * @returns PreziLink List of links that belong to the user
     * @returns Error Unexpected error
     * @throws ApiError
     */
    static get({ preziOid, userOid, listAllPrezilinks, includeSharer, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/`,
                query: {
                    'prezi_oid': preziOid,
                    'user_oid': userOid,
                    'list_all_prezilinks': listAllPrezilinks,
                    'include_sharer': includeSharer,
                },
                errors: {
                    403: `Authentication error`,
                },
            });
            return result.body;
        });
    }
    /**
     * Create new link
     * @returns PreziLink The new link
     * @returns Error Unexpected error
     * @throws ApiError
     */
    static create({ prezilink, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'POST',
                path: `/`,
                body: prezilink,
                errors: {
                    403: `Authentication error`,
                },
            });
            return result.body;
        });
    }
    /**
     * Modify links
     * @returns any prezilinks update success
     * @returns Error unexpected error
     * @throws ApiError
     */
    static update({ changes, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'PUT',
                path: `/`,
                body: changes,
            });
            return result.body;
        });
    }
    /**
     * Create or regenerate unlisted link for a document
     * @returns UnlistedLink The new link
     * @returns Error Unexpected error
     * @throws ApiError
     */
    static updateUnlistedItem({ preziOid, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'PUT',
                path: `/unlisted/${preziOid}`,
                errors: {
                    403: `Authentication error`,
                },
            });
            return result.body;
        });
    }
    /**
     * Retrieve the current unlisted link for a given document
     * @returns UnlistedLink The link
     * @returns Error Unexpected error
     * @throws ApiError
     */
    static getUnlistedItem({ preziOid, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/unlisted/${preziOid}`,
                errors: {
                    403: `Authentication error`,
                    404: `Link does not exist`,
                },
            });
            return result.body;
        });
    }
    /**
     * Revoke the unlisted link associated with the document
     * @returns DeleteUnlistedLink The link was successfully deleted
     * @returns Error Unexpected error
     * @throws ApiError
     */
    static deleteUnlistedItem({ preziOid, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'DELETE',
                path: `/unlisted/${preziOid}`,
                errors: {
                    403: `Authentication error`,
                    404: `Link does not exist`,
                },
            });
            return result.body;
        });
    }
    /**
     * Get details of link
     * @returns PreziLink The link
     * @returns Error Unexpected error
     * @throws ApiError
     */
    static getItem({ linkId, includeSharer, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'GET',
                path: `/${linkId}/`,
                query: {
                    'include_sharer': includeSharer,
                },
                errors: {
                    404: `Link does not exist`,
                },
            });
            return result.body;
        });
    }
    /**
     * Modify link
     * @returns PreziLink The updated link
     * @returns Error Unexpected error
     * @throws ApiError
     */
    static updateItem({ linkId, prezilink, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'PUT',
                path: `/${linkId}/`,
                body: prezilink,
                errors: {
                    403: `Authentication error`,
                },
            });
            return result.body;
        });
    }
    /**
     * Delete link
     * @returns DeletePreziLink Id of the deleted link
     * @returns Error Unexpected error
     * @throws ApiError
     */
    static deleteItem({ linkId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield __request({
                method: 'DELETE',
                path: `/${linkId}/`,
                errors: {
                    403: `Authentication error`,
                    404: `Link does not exist`,
                },
            });
            return result.body;
        });
    }
}
